<div
	class="keyboard-overlay bg-gray-200"
	dir="ltr"
	role="group"
	aria-label="صفحه کلید عددی"
	[class.keyboard-overlay--fixed]="positionFixed()">
	<div class="flex h-full items-stretch justify-center gap-1">
		<div class="flex h-full flex-1 flex-col gap-1 min-w-3/5">
			@for (row of layout; track $index) {
				<div class="flex flex-1 gap-1">
					@for (key of row; track key) {
						<ui-button
							class="keyboard-key"
							variant="mute"
							size="default"
							extraButtonClasses="w-full h-full bg-gray-100 text-gray-900 font-medium text-[23px] active:bg-gray-050"
							shape="rounded"
							[label]="key"
							[attr.data-cy]="'easy-keyboard-btn-' + key"
							(clicked)="press(key)" />
					}
				</div>
			}
		</div>

		<div class="flex h-full flex-1 flex-col gap-1 min-w-2/5">
			<div class="flex flex-1 flex-row-reverse gap-1">
				<ui-button
					class="keyboard-key"
					variant="mute"
					size="default"
					shape="rounded"
					extraButtonClasses="w-full h-full bg-gray-100 text-gray-900 font-medium active:bg-gray-050"
					(clicked)="delete()">
					<span class="sr-only">حذف</span>
					<ui-icon width="24" height="24" iconName="backspace" />
				</ui-button>
				<ui-button
					class="keyboard-key"
					variant="mute"
					size="default"
					shape="rounded"
					extraButtonClasses="w-full h-full bg-gray-100 text-gray-900 font-medium text-2.75 active:bg-gray-050"
					[label]="stepLabel('+')"
					(clicked)="increase()" />
			</div>

			<div class="flex flex-1 flex-row-reverse gap-1">
				<ui-button
					class="keyboard-key"
					variant="mute"
					size="default"
					shape="rounded"
					label="پاک‌کردن"
					extraButtonClasses="w-full h-full bg-gray-100 text-gray-900 font-medium text-2.75 active:bg-gray-050"
					(clicked)="deleteAll()" />
				<ui-button
					class="keyboard-key"
					variant="mute"
					size="default"
					shape="rounded"
					extraButtonClasses="w-full h-full bg-gray-100 text-gray-900 font-medium text-2.75 active:bg-gray-050"
					[label]="stepLabel('-')"
					(clicked)="decrease()" />
			</div>

			<div class="flex flex-1 flex-row-reverse gap-1">
				<ui-button
					class="keyboard-key"
					variant="mute"
					size="default"
					shape="rounded"
					extraButtonClasses="w-full h-full bg-gray-100 text-gray-900 font-medium active:bg-gray-050"
					(clicked)="cancel()">
					<span class="sr-only">بستن صفحه کلید</span>
					<ui-icon width="24" height="24" iconName="keyboard-close" />
				</ui-button>
				<ui-button
					class="keyboard-key"
					variant="mute"
					size="default"
					shape="rounded"
					label="0"
					extraButtonClasses="w-full h-full bg-gray-100 text-gray-900 font-medium text-[23px] active:bg-gray-050"
					(clicked)="press('0')" />
			</div>
		</div>
	</div>
</div>
